// extracted by mini-css-extract-plugin
export default {"underline":"Title_underline__AuFzO","section-title":"Title_section-title__sEU1Y"};